/**
 * 删除给定字符串中的空格
 * @param value 字符串
 * @param mode 模式, left:删除左边空格, right:删除右边空格, both:删除左右空格, all:删除全部空格, 默认值为'both'
 * @example {{'  空  格  '|trim}} => '空  格'
 * @example {{'  空  格  '|trim('left')}} => '空  格  '
 * @example {{'  空  格  '|trim('right')}} => '  空  格'
 * @example {{'  空  格  '|trim('all')}} => '空格'
 */
export default function (value: string = '', mode: 'left' | 'right' | 'both' | 'all' = 'both'): string{
	switch (mode) {
		case 'left':
			return String(value).replace(/^\s+/g, '');
			break;
		case 'right':
			return String(value).replace(/\s+$/g, '');
			break;
		case 'both':
			return String(value).replace(/(^\s+|\s+$)/g, '');
			break;
		case 'all':
			return String(value).replace(/\s+/g, '');
			break;
	}
	return String(value);
}
